import React, { useState, useEffect, useRef, useCallback } from "react";

import { MdEvent } from "react-icons/md";

import DashboardGreeting from "../DashboardGreeting";

import AddIcon from "../../assets/images/addIcon.svg";
import { useStateContext } from "../../contexts/ContextProvider";

import ArrowIcon from "../../assets/images/arrow-right-up.svg";

import { Link, redirect } from "react-router-dom";

import NewLeaveReq from "../../assets/images/newLeaveReq.svg";
import ApprovedReq from "../../assets/images/approvedReq.svg";
import RejectedReq from "../../assets/images/rejectedReq.svg";
import PendingReq from "../../assets/images/pendingReq.svg";
import EventIcon from "../../assets/images/event-Icon.svg";

import CakeIcon from "../../assets/images/cake2.svg";

import "../hr.css";

import Select from "react-select";

import { Calendar as MonthCalendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import moment from "moment";

import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import AddEvent from "../common/AddEvent";
import SendWish from "../common/SendWish";
import DashboardService from "../../services/dashboard.service";
import { Flex } from "antd";
Chart.register(ArcElement, Tooltip, Legend);

const monthOptions = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const currentYearNum = new Date().getFullYear();
const yearOptions = Array.from({ length: 7 }, (_, i) => {
  const y = currentYearNum - 5 + i;
  return { value: y.toString(), label: y.toString() };
});

const createTextCenterPlugin = (id) => ({
  id: id,
  beforeDraw: (chart, args, pluginOptions) => {
    const displayText =
      pluginOptions?.text ??
      chart.options?.plugins?.[id]?.text ??
      chart.config?.options?.plugins?.[id]?.text ??
      "";
    const ctx = chart.ctx;
    const width = chart.width;
    const height = chart.height;
    ctx.restore();
    ctx.font = "600 20px Jost";
    ctx.fillStyle = "rgba(110, 98, 132, 1)";
    ctx.textBaseline = "middle";

    const textString = String(displayText);
    const textX = Math.round((width - ctx.measureText(textString).width) / 2);
    const textY = height / 2;
    ctx.fillText(textString, textX, textY);
    ctx.save();
  },
});

const textCenterLocationPlugin = createTextCenterPlugin("textCenterLocation");
const textCenterAllLocationPlugin = createTextCenterPlugin("textCenterAllLocation");
const textCenterTalentPlugin = createTextCenterPlugin("textCenterTalent");

const HRDashboard = ({ user }) => {
  const navHeading = "Welcome to Leave Management!";

  const elementRef = useRef(null);

  const { event, setEvent, sendWish, setSendWish, events, locations } =
    useStateContext();

  const currentDate = new Date();
  const maxDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );

  const [date, setDate] = useState();
  const [year, setYear] = useState();

  // const [details, setDetails] = useState({
  //   month: moment(new Date(date)).format("M"),
  //   year: moment(new Date(date)).format("YYYY"),
  // });

  const [details, setDetails] = useState({
    month: "",
    year: "",
  });

  const [leaveRequest, setLeaveRequest] = useState({
    newRequest: "",
    approvedRequest: "",
    pendingRequest: "",
    rejectedRequest: "",
    total: "",
  });

  const initialData = {
    keys: [],
    data: [],
  };

  const [attendanceCount, setAttendanceCount] = useState({ initialData });
  const [attendanceCountAll, setAttendanceCountAll] = useState({ initialData });
  const [totalEmpLocation, setTotalEmpLocation] = useState("");
  const [totalEmpAllLocation, setTotalEmpAllLocation] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    label: "Pune",
    value: "25",
  });
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);

  const [selectedTalentLocation, setSelectedTalentLocation] = useState({
    label: "Pune",
    value: "Pune",
  });
  const [selectedTalentMonth, setSelectedTalentMonth] = useState({
    value: "1",
    label: "January",
  });
  const [selectedTalentYear, setSelectedTalentYear] = useState({
    value: currentYearNum.toString(),
    label: currentYearNum.toString(),
  });

  const [analyticsData, setAnalyticsData] = useState({
    totalEmp: 0,
    retentionCount: 0,
    attritionCount: 0,
    retentionPer: 0,
    attritionPer: 0,
  });

  const fetchAnalytics = useCallback(() => {
    const m = selectedTalentMonth ? selectedTalentMonth.value : null;
    const y = selectedTalentYear ? selectedTalentYear.value : null;
    const loc = selectedTalentLocation
      ? selectedTalentLocation.label || selectedTalentLocation.value
      : null;

    const payload = {
      month: m,
      year: y,
      location: loc === "All" || loc === "all" ? "" : loc,
    };

    DashboardService.getAnalytics(payload)
      .then((resp) => {
        if (resp.data) {
          setAnalyticsData(resp.data);
        }
      })
      .catch((e) => console.log(e));
  }, [selectedTalentMonth, selectedTalentYear, selectedTalentLocation]);

  useEffect(() => {
    fetchAnalytics();
  }, [fetchAnalytics]);

  const handleMonthSelectChange = (option) => {
    setSelectedMonth(option);
    const monthVal = option ? option.value : null;
    const yearVal = selectedYear ? selectedYear.value : details.year || null;

    const payload = {
      month: monthVal,
      year: yearVal,
    };
    if (user.role !== "1" || user.role !== "4") {
      fetchLeaveReqCount(payload);
    }

    setDetails((prevState) => ({
      ...prevState,
      month: monthVal,
    }));
  };

  const handleYearSelectChange = (option) => {
    setSelectedYear(option);
    const yearVal = option ? option.value : null;
    const monthVal = selectedMonth
      ? selectedMonth.value
      : details.month || null;

    const payload = {
      month: monthVal,
      year: yearVal,
    };
    if (user.role !== "1" || user.role !== "4") {
      fetchLeaveReqCount(payload);
    }

    setDetails((prevState) => ({
      ...prevState,
      year: yearVal,
    }));
  };

  const fetchAttandanceCountLocationWise = useCallback(() => {
    const payload = {
      location: selectedLocation.label,
    };
    DashboardService.getAttendeceCount(payload)
      .then((resp) => {
        if (resp.data) {
          setTotalEmpLocation(resp.data.totalEmp);
          const attendanceCount = Object.entries(resp.data);
          const filteredAttendanceCount = attendanceCount.filter(
            (item) => item[0] !== "location" && item[0] !== "totalEmp",
          );

          // console.log("attendanceCount", filteredAttendanceCount)

          setAttendanceCount({
            keys: filteredAttendanceCount,
            data:
              filteredAttendanceCount &&
              filteredAttendanceCount.map((item) => item[1]),
          });
        }
      })
      .catch((e) => console.log(e));
  }, [selectedLocation.label]);

  const fetchAttandanceCountAllLocation = () => {
    const payload = {};

    DashboardService.getAttendeceCount(payload)
      .then((resp) => {
        if (resp.data) {
          setTotalEmpAllLocation(resp.data.totalEmp);
          const attendanceCount = Object.entries(resp.data);
          const filteredAttendanceCount = attendanceCount.filter(
            (item) => item[0] !== "location" && item[0] !== "totalEmp",
          );

          setAttendanceCountAll({
            keys: filteredAttendanceCount,
            data:
              filteredAttendanceCount &&
              filteredAttendanceCount.map((item) => item[1]),
          });
        }
      })
      .catch((e) => console.log(e));
  };

  const handleChange = (option) => {
    setSelectedLocation(option);
  };

  useEffect(() => {
    fetchAttandanceCountLocationWise();
  }, [fetchAttandanceCountLocationWise]);

  useEffect(() => {
    fetchAttandanceCountAllLocation();
  }, []);

  const fetchLeaveReqCount = useCallback((payload) => {
    DashboardService.getLeaveReqCount(payload)
      .then((resp) => {
        setLeaveRequest(resp.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    if (user.role === "1" || user.role === "4") {
      const payload = {
        month: null,
        year: null,
      };
      fetchLeaveReqCount(payload);
    }
  }, [fetchLeaveReqCount, user]);

  const handleDateChange = (e) => {
    setDate(e.value);

    if (!e.value) {
      // Clear filter logic
      setDetails({
        month: null,
        year: null,
      });
      // Optionally, fetch unfiltered leave request count
      if (user.role !== "1" || user.role !== "4") {
        fetchLeaveReqCount({ month: null, year: null });
      }
      return;
    }

    const month = moment(new Date(e.value)).format("M");
    const year = moment(new Date(e.value)).format("YYYY");

    const payload = {
      month: month,
      year: details.year ? details.year : year,
    };
    if (user.role !== "1" || user.role !== "4") {
      fetchLeaveReqCount(payload);
    }

    setDetails((prevState) => ({
      ...prevState,
      month: month,
    }));
  };

  const handleYearChange = (e) => {
    setYear(e.value);

    if (!e.value) {
      // Clear filter logic
      setDetails({
        month: null,
        year: null,
      });
      // Optionally, fetch unfiltered leave request count
      if (user.role !== "1" || user.role !== "4") {
        fetchLeaveReqCount({ month: null, year: null });
      }
      return;
    }

    const year = moment(new Date(e.value)).format("YYYY");

    const payload = {
      month: details.month ? details.month : null,
      year: year,
    };
    if (user.role !== "1" || user.role !== "4") {
      fetchLeaveReqCount(payload);
    }

    setDetails((prevState) => ({
      ...prevState,
      year: year,
    }));
  };

  const data = {
    labels: ["Present", "Absent", "On Leave", "Late Mark", "Half Day", "WHF"],
    datasets: [
      {
        label: "Today's Attendance",
        data: attendanceCount.data,
        backgroundColor: [
          "rgba(45, 206, 137, 1)",
          "rgba(255, 0, 0, 1)",
          "rgba(249, 133, 133, 1)",
          "rgba(254, 224, 105, 1)",
          "rgba(255, 192, 103, 1)",
          "rgba(246, 60, 60, 1)",
        ],
        borderWidth: 2,
        borderRadius: 4,
      },
    ],
  };

  const data2 = {
    labels: ["Present", "Absent", "On Leave", "Late Mark", "Half Day", "WHF"],
    datasets: [
      {
        label: "Today's Attendance",
        data: attendanceCountAll.data,
        backgroundColor: [
          "rgba(45, 206, 137, 1)",
          "rgba(255, 0, 0, 1)",
          "rgba(249, 133, 133, 1)",
          "rgba(254, 224, 105, 1)",
          "rgba(255, 192, 103, 1)",
          "rgba(246, 60, 60, 1)",
        ],
        borderWidth: 2,
        borderRadius: 4,
      },
    ],
  };

  const data3 = {
    labels: ["Retention", "Attrition"],
    datasets: [
      {
        label: "Talent Stability",
        data: [
          analyticsData?.retentionCount ?? 0,
          analyticsData?.attritionCount ?? 0,
        ],
        backgroundColor: ["rgba(45, 206, 137, 1)", "rgba(255, 0, 0, 1)"],
        borderWidth: 2,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    cutout: 50,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
    },
    responsive: true,
  };



  return (
    <>
      <div className="dashboard-container hr">
        <div ref={elementRef}>
          <DashboardGreeting navHeading={navHeading} user={user} />
          <div className="filterBar mb-3 d-flex justify-content-between">
            <div className="heading arrow-flex">
              <span>Leave Request Stats</span>
              {user.role === "1" || user.role === "4" ? (
                <Link to={"/leaveRequest"}>
                  <span className="arrow">
                    <img src={ArrowIcon} alt="" />
                  </span>
                </Link>
              ) : (
                <></>
              )}
            </div>
            <div className="topbar">
              <div className="new-calendar-type flex justify-content-center month-year">
                <Flex gap={10}>
                  <MonthCalendar
                    value={date}
                    onChange={handleDateChange}
                    view="month"
                    placeholder="Select Month"
                    dateFormat="MM"
                    style={{ width: "100%" }}
                    showIcon
                    showButtonBar
                    yearNavigator={false}
                    monthNavigator={true}
                    panelClassName="month-only-calendar"
                  />
                  <MonthCalendar
                    value={year}
                    onChange={handleYearChange}
                    view="year"
                    placeholder="Select Year"
                    dateFormat="yy"
                    style={{ width: "100%" }}
                    showIcon
                    maxDate={maxDate}
                    showButtonBar
                  />
                </Flex>
              </div>
              {user.role !== "4" ? (
                <>
                  <div className="action">
                    <button
                      className="apply"
                      onClick={(e) => {
                        setEvent(true);
                      }}
                    >
                      <span>
                        <img src={AddIcon} alt="add event" />
                      </span>
                      <span>Add Event</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>

        <div>
          <div className="emp-stats">
            <div className="monthly mb-3">
              <div className="d-flex mb-3"></div>
              <div className="list">
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 4 }}>
                    <div className="flex">
                      <div className="text">
                        <span>New</span>
                        <span className="count">{leaveRequest.newRequest}</span>
                      </div>
                      <div className="icon">
                        <img src={NewLeaveReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 2 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Approved</span>
                        <span className="count">
                          {leaveRequest.approvedRequest}
                        </span>
                      </div>
                      <div className="icon">
                        <img src={ApprovedReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 3 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Rejected</span>
                        <span className="count">
                          {leaveRequest.rejectedRequest}
                        </span>
                      </div>
                      <div className="icon">
                        <img src={RejectedReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 1 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Pending</span>
                        <span className="count">
                          {leaveRequest.pendingRequest}
                        </span>
                      </div>
                      <div className="icon">
                        <img src={PendingReq} alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="item">
                  <Link to={"/leaveRequest"} state={{ redirectIndex: 0 }}>
                    <div className="flex">
                      <div className="text">
                        <span>Total</span>
                        <span className="count">{leaveRequest.total}</span>
                      </div>
                      <div className="icon">
                        {/* <img src={TotalLeaveReq} alt="" /> */}
                        <span>
                          <svg
                            version="1.1"
                            baseProfile="basic"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="70"
                            height="70"
                            viewBox="0 0 71 71"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              d="M59.2,41.4H8.9"
                            />
                            <path
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              d="M32.5,53.2H8.9"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="8.9"
                              y1="17.8"
                              x2="39.9"
                              y2="17.8"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="59.2"
                              y1="17.8"
                              x2="52.5"
                              y2="17.8"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="59.2"
                              y1="29.6"
                              x2="28.1"
                              y2="29.6"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="8.9"
                              y1="29.6"
                              x2="15.5"
                              y2="29.6"
                            />
                            <line
                              fill="none"
                              stroke="#3B82F6"
                              strokeWidth="4.4"
                              strokeLinecap="round"
                              x1="46.9"
                              y1="53.2"
                              x2="59.2"
                              y2="53.2"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="attendance mb-4">
            <div className="row">
              <div className="col-lg-4">
                <div className="selectedLocations">
                  <div className="heading w-100 justify-content-between">
                    <span className="text1">Today’s Attendance</span>
                    <Select
                      value={selectedLocation}
                      onChange={handleChange}
                      options={locations}
                      placeholder="Select Location"
                      title={"123"}
                      styles={{
                        menu: (base) => ({
                          ...base,
                          width: "150px",
                        }),
                      }}
                    />
                  </div>
                  <div className="flex mb-3">
                    <div className="chart">
                      <Doughnut
                        data={data}
                        options={{
                          ...options,
                          plugins: {
                            ...options.plugins,
                            textCenterLocation: {
                              text: `${totalEmpLocation ?? 0}`,
                            },
                          },
                        }}
                        plugins={[textCenterLocationPlugin]}
                        width="150px"
                        height="150px"
                      />
                    </div>
                    <div className="chart-counts">
                      {Array.isArray(attendanceCount.keys)
                        ? attendanceCount.keys.map((item) => {
                            return (
                              <React.Fragment key={item[0]}>
                                <div className={`chart-flex ${item[0]}`}>
                                  <div className="chart-content">
                                    <div className="circle"></div>
                                    <div className="content">
                                      <span>
                                        {item[0] === "onleave"
                                          ? "On Leave"
                                          : item[0] === "latemark"
                                            ? "Late Mark"
                                            : item[0] === "halfDay"
                                              ? "Half Day"
                                              : item[0] === "whf"
                                                ? "WFH"
                                                : item[0]}{" "}
                                        -
                                      </span>
                                    </div>
                                  </div>
                                  <div className="count">
                                    <span>
                                      {item[1] !== null ? item[1] : "0"}
                                    </span>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })
                        : null}
                    </div>
                  </div>
                  <div className="totalEmpCounts">
                    <span>Total Employees:</span>
                    <strong>{totalEmpLocation}</strong>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="allLocations">
                  <div className="heading">
                    <span className="text1">All Locations</span>
                  </div>
                  <div className="flex mb-3">
                    <div className="chart">
                      <Doughnut
                        data={data2}
                        options={{
                          ...options,
                          plugins: {
                            ...options.plugins,
                            textCenterAllLocation: {
                              text: `${totalEmpAllLocation ?? 0}`,
                            },
                          },
                        }}
                        plugins={[textCenterAllLocationPlugin]}
                        width="150px"
                        height="150px"
                      />
                    </div>
                    <div className="chart-counts">
                      {Array.isArray(attendanceCountAll.keys)
                        ? attendanceCountAll.keys.map((item) => {
                            return (
                              <React.Fragment key={item[0]}>
                                <div className={`chart-flex ${item[0]}`}>
                                  <div className="chart-content">
                                    <div className="circle"></div>
                                    <div className="content">
                                      <span>
                                        {item[0] === "onleave"
                                          ? "On Leave"
                                          : item[0] === "latemark"
                                            ? "Late Mark"
                                            : item[0] === "halfDay"
                                              ? "Half Day"
                                              : item[0] === "whf"
                                                ? "WFH"
                                                : item[0]}{" "}
                                        -
                                      </span>
                                    </div>
                                  </div>
                                  <div className="count">
                                    <span>
                                      {item[1] !== null ? item[1] : "0"}
                                    </span>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })
                        : null}
                    </div>
                  </div>
                  <div className="totalEmpCounts">
                    <span>Total Employees:</span>
                    <strong>{totalEmpAllLocation}</strong>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="talentStability">
                  <div className="heading w-100 justify-content-between flex-wrap gap-2">
                    <span className="text1">Talent Stability</span>
                    <Flex gap={6} align="center">
                      <Select
                        value={selectedTalentMonth}
                        onChange={(option) => setSelectedTalentMonth(option)}
                        options={monthOptions}
                        placeholder="Month"
                        menuPortalTarget={document.body}
                        styles={{
                          container: (base) => ({ ...base, width: "100px" }),
                          control: (base) => ({
                            ...base,
                            minHeight: "32px",
                            height: "32px",
                            fontSize: "12px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "32px",
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                      <Select
                        value={selectedTalentYear}
                        onChange={(option) => setSelectedTalentYear(option)}
                        options={yearOptions}
                        placeholder="Year"
                        menuPortalTarget={document.body}
                        styles={{
                          container: (base) => ({ ...base, width: "85px" }),
                          control: (base) => ({
                            ...base,
                            minHeight: "32px",
                            height: "32px",
                            fontSize: "12px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "32px",
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                      <Select
                        value={selectedTalentLocation}
                        onChange={(option) => setSelectedTalentLocation(option)}
                        options={locations}
                        placeholder="Location"
                        menuPortalTarget={document.body}
                        styles={{
                          container: (base) => ({ ...base, width: "115px" }),
                          control: (base) => ({
                            ...base,
                            minHeight: "32px",
                            height: "32px",
                            fontSize: "12px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "32px",
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </Flex>
                  </div>
                  <div className="flex mb-3">
                    <div className="chart chart-new">
                      <Doughnut
                        data={data3}
                        options={{
                          ...options,
                          plugins: {
                            ...options.plugins,
                            textCenterTalent: {
                              text: `${analyticsData?.totalEmp ?? 0}`,
                            },
                          },
                        }}
                        plugins={[textCenterTalentPlugin]}
                        width="150px"
                        height="150px"
                      />
                    </div>
                    <div className="chart-counts">
                      <div className={`chart-flex`}>
                        <div className="chart-content">
                          <div className="circle"></div>
                          <div className="content">
                            <span>Retention:</span>
                          </div>
                        </div>
                        <div className="count">
                          <span>{analyticsData?.retentionCount ?? 0}</span>
                        </div>
                      </div>
                      <div className={`chart-flex`}>
                        <div className="chart-content">
                          <div className="circle"></div>
                          <div className="content">
                            <span>Attrition:</span>
                          </div>
                        </div>
                        <div className="count">
                          <span>{analyticsData?.attritionCount ?? 0}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="totalEmpCounts">
                    <span>Total Employees:</span>
                    <strong>{analyticsData?.totalEmp ?? 0}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${
              event || sendWish ? "hr-events visible" : "hr-events"
            }`}
          >
            <div className="flex mb-3">
              <div className="left-flex">
                <span className="icon">
                  <MdEvent size={30} color="#4E465E" />
                </span>
                <span>Today’s Events</span>
              </div>
              <div className="right-flex">
                {/* <MonthCalendar
                  value={date}
                  onChange={handleDateChange}
                  view="date"
                  dateFormat="dd, MM, yy"
                  style={{ height: "100%" }}
                  showIcon
                  maxDate={maxDate}
                /> */}
              </div>
            </div>
            <div className="list">
              {Array.isArray(events)
                ? events.map((item) => {
                    return (
                      <React.Fragment key={item.id}>
                        <div className="item">
                          <div className="profile">
                            <div className="p-circle">
                              <span>
                                <img
                                  src={`https://elmsbk.aeontechhub.com/ProfilePic/${item.empId}/${item.profile}`}
                                  alt=""
                                />
                              </span>
                            </div>
                            <div className="name">
                              <span>{item.name}</span>
                            </div>
                            <div className="wish">
                              <span>{item.title}</span>
                            </div>
                            {/* <div className="action">
                              <button
                                onClick={(e) => {
                                  setSendWish(true);
                                }}
                              >
                                Send Wish
                              </button>
                            </div> */}
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })
                : null}
            </div>
            <div className="cakeIcon">
              <img src={CakeIcon} alt="" />
            </div>
          </div>

          <div
            className={`${event ? "modal-overlay" : ""}`}
            onClick={(e) => {
              setEvent(false);
            }}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <AddEvent />
            </div>
          </div>

          <div
            className={`${sendWish ? "modal-overlay" : ""}`}
            onClick={(e) => {
              setSendWish(false);
            }}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <SendWish />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HRDashboard;
